// Description: Form functionality and RadEditor setup.

/**
 * Sets up the RadEditor fields.
 * @returns {boolean} Returns false if the current URL contains "/policies/edit", otherwise returns undefined.
 */
const setupRadEditorFields = () => {
    if (window.location.href.includes("/policies/edit")) {
        return false;
    }
    const radEditorFields = document.querySelectorAll(".RadEditor_WP");
    radEditorFields.forEach(addRadEditorEventListeners);
};

/**
 * Adds event listeners to the RadEditor element.
 * @param {HTMLElement} element - The RadEditor element.
 */
const addRadEditorEventListeners = (element) => {
    document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(element);
        withinBoundaries ? toggleElementFocus(element, true) : toggleElementFocus(element, false);
    });

    element.addEventListener('click', event => {
        if (document.activeElement === element.querySelector('.reContentArea')) {
            toggleElementFocus(element, true);
        }
    });
};

/**
 * Toggles the hover state of an element.
 * @param {HTMLElement} element - The element to toggle the hover state.
 * @param {boolean} isHovered - Indicates whether the element is being hovered or not.
 */
const toggleElementHover = (element, isHovered) => {
    isHovered ? element.classList.add('hovered') : element.classList.remove('hovered');
};

/**
 * Toggles the focus state of an element.
 * @param {HTMLElement} element - The element to toggle the focus state.
 * @param {boolean} isFocused - Indicates whether the element is being focused or not.
 */
const toggleElementFocus = (element, isFocused) => {
    isFocused ? element.classList.add('focused') : element.classList.remove('focused');
};

/**
 * Removes the tooltip from the RadEditor.
 * @param {object} editor - The RadEditor instance.
 */
const removeRadEditorTooltip = (editor) => {
    const contentAreaEl = editor.get_contentAreaElement();
    contentAreaEl.removeAttribute("title");
};

/**
 * Fixes the height of the RadEditor.
 * @param {object} editor - The RadEditor instance.
 */
const fixRadEditorHeight = (editor) => {
    const height = editor.get_element().getAttribute("fix-height");
    const minHeight = editor.get_element().getAttribute("fix-min-height");
    const contentArea = editor.get_contentArea();
    const contentAreaElement = editor.get_contentAreaElement();
    const parentElement = contentAreaElement.parentElement;
    const parentParentElement = parentElement.parentElement;

    contentArea.style.height = height;
    contentArea.style.minHeight = minHeight;
    parentElement.style.height = height;
    parentParentElement.style.height = height;
};

/**
 * Performs basic setup for the RadEditor.
 * @param {object} editor - The RadEditor instance.
 */
const basicEditorLoad = (editor) => {
    removeRadEditorTooltip(editor);
    fixRadEditorHeight(editor);
};

/**
 * Sets up an event listener for the Enter key press on a search field.
 * @param {string} searchFieldId - The ID of the search field element.
 * @param {string} searchButtonId - The ID of the search button element.
 */
const setEnterKeyPressListener = (searchFieldId, searchButtonId) => {
    const searchField = document.getElementById(searchFieldId);
    const searchButton = document.getElementById(searchButtonId);

    if (searchField && searchButton) {
        searchField.addEventListener('keypress', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                searchButton.click();
            }
        });
    }
};

